export default {
  namespaced: true,
  state: {
    customerActivities: [],
    count: 0,
  },
  getters: {
    customerActivities: (state) => state.customerActivities,
    count: (state) => state.count,
  },
  mutations: {
    customerActivities: (state, payload) => (state.customerActivities = payload),
    count: (state, payload) => (state.count = payload),
  },
  actions: {
    list({ commit }, queryParams) {
      return this.$apiService
        .get("/customer-activities", {
          params: queryParams,
        })
        .then((res) => {
          commit("customerActivities", res?.data?.data ?? []);
          commit("count", res?.data?.total ?? 0);
          return res;
        });
    },
    create({}, payload) {
      return this.$apiService.post("/customer-activities", payload);
    },
    show({}, id) {
      return this.$apiService.get(`/customer-activities/${id}`);
    },
    update({}, { id, data }) {
      return this.$apiService.put(`/customer-activities/${id}`, data);
    },
    destroy({}, id) {
      return this.$apiService.delete(`/customer-activities/${id}`);
    },
  },
};
